import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'PokerChipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-poker-chip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 17v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 12h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18.364 5.636l-2.828 2.828"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.464 15.536l-2.828 2.828"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5.636 5.636l2.828 2.828"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.536 15.536l2.828 2.828"
    }, null), _createTextVNode(" ")]);
  }
};